import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";
import { ChargePage } from "./pages/ChargesPage";
import { ChargeSelectionScreen } from "@/pages/sy/crane/ChargeSelectionScreen";
import { ChargeOperationScreen } from "@/pages/sy/crane/ChargeOperationScreen";
import { chargesThemeExtension } from "@/pages/sy/theme/chargesTheme";

type Props = {};
const ChargeManagement = (props: Props) => {
  const baseTheme = useTheme();

  // Create extended theme with charges management colors
  const extendedTheme = createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      ...chargesThemeExtension.palette,
    },
  });

  return (
    <ThemeProvider theme={extendedTheme}>
      <Routes>
        <Route index element={<ChargePage />} />
        <Route path="new" element={<ChargePage />} />
        <Route path=":chargeId" element={<ChargePage />} />
        <Route path="selection" element={<ChargeSelectionScreen />} />
        <Route
          path="operation/:chargeId/:action/:chargeGroupNumber?"
          element={<ChargeOperationScreen />}
        />
      </Routes>
    </ThemeProvider>
  );
};

export default ChargeManagement;
